import React from 'react';
import { Dropdown } from '@bynder/design-system';
import { IconLanguage } from '@bynder/icons';
import { useTranslate } from '@bynder/localization';
import { Can } from '../../abilities/Can';
import { iconSizeMedium } from '../../helpers/iconSizes';
import { LanguageMenuItems } from '../UserMenu/LanguageMenu/LanguageMenuItems';
import { LiWithFocusHighlight } from '../CommonStyles';

export function PublicMenu() {
	const { translate } = useTranslate();

	return (
		<ul className="admin-options" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
			<Dropdown
				trigger={({ isOpen, ...triggerProps }) => (
					<LiWithFocusHighlight
						className={`touch-block ${isOpen ? 'hover' : ''}`}
						{...triggerProps}
					>
						<a
							href="#"
							className="admin-option sub"
							style={{ display: 'flex', alignItems: 'center', gap: 4 }}
						>
							<IconLanguage size={iconSizeMedium} />
							<div style={{ lineHeight: iconSizeMedium }}>
								{translate('generalLanguage')}
							</div>
						</a>
					</LiWithFocusHighlight>
				)}
				minWidth="240px"
				noMaxHeight
			>
				<LanguageMenuItems />
			</Dropdown>

			<LiWithFocusHighlight className="touch-block">
				<a title={translate('generalLogin')} className="profile" href="/login">
					{translate('generalLogin')}
				</a>
			</LiWithFocusHighlight>

			<Can I="show" a="user_request">
				<LiWithFocusHighlight>
					<a
						href="/user/login/?requestAccess"
						title={translate('request.requestAccess')}
						className="account-request"
					>
						{translate('request.requestAccess')}
					</a>
				</LiWithFocusHighlight>
			</Can>
		</ul>
	);
}
